import { dataAPI } from "../api"
import { Workspace } from "../../models"
import { WorkspaceOData, WorkspacesODataResponse } from "../models/workspace"
import { ODataGetArrayResponse } from "../models/api/data"

export const getWorkspaces = (
    filter: string,
    limit: number,
    offset: number,
): Promise<WorkspacesODataResponse> =>
    dataAPI
        .getJSON<ODataGetArrayResponse<WorkspaceOData>>("workspaces", {
            $top: limit,
            $skip: offset,
            $filter: filter,
            $orderby: "label",
            $count: true,
        })
        .then((response) => ({
            count: response["@count"] ?? 0,
            workspaces: response.value.map(
                (ws): Workspace => ({
                    code: ws.Code,
                    id: ws.Id,
                    isActive: ws.IsActive,
                    label: ws.Label,
                }),
            ),
        }))
